import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes.js';
import App from './App.vue';

import Pagination from 'vue-pagination-2';
import ButtonBase from './components/ui/ButtonBase.vue';
import CardBase from './components/ui/CardBase.vue';
import ModalBase from './components/ui/ModalBase.vue';
import vuescroll from 'vuescroll';

Vue.component('pagination-base', Pagination);
Vue.component('button-base', ButtonBase);
Vue.component('card-base', CardBase);
Vue.component('modal-base', ModalBase);
Vue.component('vue-scroll', vuescroll);

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});